import * as yup from 'yup'

export const schema = yup.object({
    files: yup.array().min(1),
})
